<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//  import 'normalize.css';
export default {
  name: 'app',
};
</script>

<style>
  html,body {
    height: 100%;
    font-family: PingFang SC,\\82F9\65B9,Hiragino Sans GB,Microsoft Yahei,\\5FAE\8F6F\96C5\9ED1,Microsoft Yahei UI,Segoe UI,Tahoma,"\5B8B\4F53  b8b\4F53",SimSun,sans-serif;
  }
#app {
  min-height: 100%;
  background: #e5e5e5;
  overflow: scroll;
  height: 100%;
  /* margin-bottom: 1.28rem; */
}
</style>



// WEBPACK FOOTER //
// App.vue?59587d91